import React, { useRef } from 'react'
import { constants } from 'mage-deps/@klarna/bubble-ui'
import { MP_UI_TOPBAR_HEIGHT } from '../../../constants'
import { useHelpContext } from '../hooks'
import Router from '../Router'
import ViewportHeader from './ViewportHeader'
import ErrorBoundary from '../ErrorBoundary'
import ChatButton from '../ChatButton'
import { useSelector } from 'react-redux'
import { selectors as conversationSelectors } from 'mage-conversation'

export default function FullScreenViewport() {
  const scrollableContainer = useRef(null)

  const isChatAvailable = useSelector(conversationSelectors.markets).length > 0

  const {
    sidebar: { isOpen }
  } = useHelpContext()

  return isOpen ? (
    <>
      <div
        ref={scrollableContainer}
        style={{
          position: 'absolute',
          top: MP_UI_TOPBAR_HEIGHT - 1,
          left: 0,
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
          zIndex: constants.Layers.DIALOG,
          overflow: 'scroll'
        }}
      >
        <ErrorBoundary showErrorPage>
          <ViewportHeader />
          <div style={{ padding: 30, paddingBottom: 80 }}>
            <Router />
          </div>
          {isChatAvailable && <ChatButton container={scrollableContainer.current} />}
        </ErrorBoundary>
      </div>
    </>
  ) : null
}
